import { render } from "./course-layout-breadcrumb.vue?vue&type=template&id=78eb6938"
import script from "./course-layout-breadcrumb.vue?vue&type=script&lang=js"
export * from "./course-layout-breadcrumb.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__